/* eslint-disable no-console */
<template>
    <div>
      <div class="header_unit header_bg_white">
        <div class="header_box">
          <div class="menu_left">
            <router-link class="icn_back_black" :to="{ name: 'managemenu' , params: {brandPath: this.$route.params.brandPath}} "><p class="top_tit">＜戻る</p></router-link>
          </div>
          <div class="menu_center">
            <p class="menu_center_tex_l top_tit">ダッシュボード 表示設定</p>
          </div>
        </div>
      </div>
      <div class="main_unit menu_center">
        <div class="top_unit">
          <div class="top_name_box">企業管理者</div>
          <div class="top_center_box"> </div>
        </div>

        <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        <div v-if="apivalidationMessage" class="mgt_20 mgb_20 mgl_20">
          <Message :validationMessage="apivalidationMessage" />
        </div>
        <div style="display: flex;flex-wrap: nowrap; justify-content: center" v-show="!isLoading">

          <div v-show="showContent" class="dashboard_view_setting_List_tbl_unit tbl_bg_blue mgt_15">
            <div style="display: flex;align-items: center;justify-content: space-between; padding:20px;">
              <h1>グラフ表示</h1>
              <div class="btn_submit letter_spa" style="margin: 0;">
                <a href="#" @click.prevent.stop="checkFrom">更新</a>
              </div>
            </div>
            <div  style="padding: 20px" id="viewSetting" name="viewSetting">
              <table >
                <tr>
                  <th class="wd140 checkSetting_text_align">表示順</th>
                  <th class="wd160 checkSetting_text_align">グラフ名</th>
                  <th class="wd160 checkSetting_text_align">設定内容</th>
                  <th class="wd180 checkSetting_text_align" style="min-width: 87px">変更</th>
                </tr>
                <tr v-for="viewSetting in viewSettingList" :key=viewSetting.viewSettingNo>
                  <td class="wd140 checkSetting_text_align">{{viewSetting.viewSettingNo}}</td>
                  <td class="wd160 checkSetting_text_align">{{viewSetting.itemName}}</td>
                  <td class="wd160 checkSetting_text_align">{{viewSetting.nowDisplayFlg}}</td>
                  <td class="alertList_text_align dashboard_staff_kanri_box">
                      <div class="form-check form-check-inline wd70">
                        <input class="form-check-input display_radio" :id="viewSetting.viewSettingNo" :name="viewSetting.viewSettingNo" type="radio" value='1' v-model="viewSetting.displayFlg">
                        <label class="form-check-label" :for="viewSetting.viewSettingNo">表示</label>
                      </div>
                      <div class="form-check form-check-inline wd70">
                        <input class="form-check-input display_radio" :id="viewSetting.viewSettingNo" :name="viewSetting.viewSettingNo" type="radio" value='0' v-model="viewSetting.displayFlg">
                        <label class="form-check-label" :for="viewSetting.viewSettingNo">非表示</label>
                      </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="overlay" v-show="showContent2">
        <div>
          <div class="modal_box wd512">
            <div class="modal_header_unit">
              <div class="modal_header_box">
                <p class="modal_header_tit_s"></p>
                <p class="modal_header_tit">ダッシュボード表示設定 登録</p>
              </div>
            </div>
            <div class="modal_content_tex">
              <p>表示設定の登録が完了しました。</p>
            </div>
            <div class="btn_submit_box">
              <div class="btn_submit2">
                <a role="button" @click.prevent.stop="closeModal()">閉じる</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import PulseLoader from '@/app/components/PulseLoader.vue'
import Message from '@/app/components/Message.vue'

export default {
  name: "DashboardViewSetting",
  components: {
    PulseLoader,
    Message,
  },
  created() {
    // 年月セット
    this.calc()
  },
  data: function () {
    return {
      showContent: true,
      showContent2: false,
      isLoading: false,
      apiValidationMessage: "",
      addFormFlg: true,
      viewSettingList:[],
      viewSetting:[],
    }
  },
  computed: {
    brandPath: function () {
      return this.$store.getters['brand/path']
    },
  },
  methods: {
    async calc() {
      this.isLoading = true;
      let brandId = this.$store.getters['brand/id'];
      this.apivalidationMessage = "";

      //取得API呼び出し
      await this.$axios
          .get(this.$apiEndpoint + 'manage/brand/' + brandId + '/dashboard/viewSetting')
          .then(response => {
            this.viewSettingList = response['data']['viewSettings'];
            this.viewSettingList.forEach(viewSetting => {
              if(viewSetting["displayFlg"]){
                viewSetting["nowDisplayFlg"] = "表示";
              } else {
                viewSetting["nowDisplayFlg"] = "非表示";
              }
            });
            this.showContent = true;
          })
          .catch((err) => {
            let error = {
              button: {
                path: {name: 'top', params:{brandPath: this.brandPath}}
              }}
            if (err.customError) {
              error = Object.assign(error, err.customError);

              if(error.code == 400){
                this.apivalidationMessage =  error.message;
              }
              if(error.code !== 400){
                this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
              }
            }
          }).finally(()=> this.isLoading = false);
    },
    checkFrom: function() {
      this.addFormFlg = true;
      this.isLoading = true;
      this.apivalidationMessage = '';
      this.viewSettingList.forEach(viewSetting => {
        if(viewSetting.displayFlg == null){
          this.apivalidationMessage="表示設定を入力してください。"
          this.addFormFlg = false;
          this.isLoading = false;
        }
        if(viewSetting.displayFlg != 0 && viewSetting.displayFlg != 1){
          this.apivalidationMessage="表示設定の形式が正しくありません。"
          this.addFormFlg = false;
          this.isLoading = false;
        }
      });
      if(this.addFormFlg) {
        this.update();
      }
    },
    update: async function() {
      const brandId = this.$store.getters['brand/id']
      // request作成
      var requestBody = {}
      var view_settings = [];
      this.viewSettingList.forEach(viewSetting => {
        var view_setting = {
          fk_brand_id: viewSetting.fkBrandId,
          view_setting_no: viewSetting.viewSettingNo,
          display_flg: viewSetting.displayFlg,
        }
        view_settings.push(view_setting);
      });
      requestBody.view_settings = view_settings;
      var formRequestBody = this.jsonToFormData(requestBody);

      var config = {
        headers: {
          'Content-Type': 'multipart/form-data;'
        }
      }
      await this.$axios
          .post(this.$apiEndpoint + 'manage/brand/' + brandId + '/dashboard/viewSetting/update', formRequestBody, config)
          .then(() => {
            this.showContent2 = true;
            this.addFormFlg = false;
          })
          .catch((err) => {
            let error = {
              button: {
                path: {name: 'top', params: {brandPath: this.brandPath}}
              }
            }
            if (err.customError) {
              error = Object.assign(error, err.customError);

              if(error.code == 400){
                this.apivalidationMessage =  error.message;
              }
              if(error.code !== 400){
                this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
              }
            }
          }).finally(() => this.isLoading = false);
    },
    closeModal() {
      this.calc()
      this.showContent2 = false;
    },
    buildFormData(formData, data, parentKey) {
      if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach(key => {
          this.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
        });
      } else {
        const value = data == null ? '' : data;

        formData.append(parentKey, value);
      }
    },
    jsonToFormData(data) {
      const formData = new FormData();

      this.buildFormData(formData, data);

      return formData;
    },
  }
}
</script>